import { ErrorHandler, Injectable, inject } from '@angular/core';
import {Logger} from './default-log.service';

@Injectable()
export class SystemMonitorErrorHandler extends ErrorHandler {
	private logger = inject(Logger);

	constructor() {
		super();
		const logger = this.logger;

		this.logger = logger;
	}

	handleError(error: any): void {
		this.logger.error('Unhandled exception occurred', error);

		super.handleError(error);
	}
}
